import { DeleteOutlined, FolderAddOutlined, FolderOpenOutlined, LockOutlined } from '@ant-design/icons';
import styled from 'styled-components';
const style = `
background: rgba(255, 186, 0, 0.1);
border-radius: 50%;
color: #98a9bc;
padding: 5px;
font-size: 36px !important;
margin-top: 30px;
`;
export const AddFolderIcon = styled(FolderAddOutlined)`
  ${style}
`;
export const RemoveFolderIcon = styled(DeleteOutlined)`
  ${style}
`;
export const LockOutlinedIcon = styled(LockOutlined)`
  ${style}
`;
export const MoveFolderIcon = styled(FolderOpenOutlined)`
  ${style}
`;